import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const POST_WCC_MOT_SUCCESS = 'POST_WCC_MOT_SUCCESS';
export const POST_WCC_MOT_FAIL = 'POST_WCC_MOT_FAIL';
export const POST_WCC_MOT_REQUEST = 'POST_WCC_MOT_REQUEST';

export const LOAD_WCC_MOT_SUCCESS = 'LOAD_WCC_MOT_SUCCESS';
export const LOAD_WCC_MOT_FAIL = 'LOAD_WCC_MOT_FAIL';
export const LOAD_WCC_MOT_REQUEST = 'LOAD_WCC_MOT_REQUEST';

export const LOAD_WCC_MOT_DATA_SUCCESS = 'LOAD_WCC_MOT_DATA_SUCCESS';
export const LOAD_WCC_MOT_DATA_FAIL = 'LOAD_WCC_MOT_DATA_FAIL';
export const LOAD_WCC_MOT_DATA_REQUEST = 'LOAD_WCC_MOT_DATA_REQUEST';

export const LOAD_MANUFACTURING_ORDER_TYPES_SUCCESS = 'LOAD_MANUFACTURING_ORDER_TYPES_SUCCESS';
export const LOAD_MANUFACTURING_ORDER_TYPES_FAIL = 'LOAD_MANUFACTURING_ORDER_TYPES_FAIL';
export const LOAD_MANUFACTURING_ORDER_TYPES_REQUEST = 'LOAD_MANUFACTURING_ORDER_TYPES_REQUEST';

export const PUT_WCC_MOT_SUCCESS = 'PUT_WCC_MOT_SUCCESS';
export const PUT_WCC_MOT_FAIL = 'PUT_WCC_MOT_FAIL';
export const PUT_WCC_MOT_REQUEST = 'PUT_WCC_MOT_REQUEST';

export const DELETE_WCC_MOT_SUCCESS = 'DELETE_WCC_MOT_SUCCESS';
export const DELETE_WCC_MOT_FAIL = 'DELETE_WCC_MOT_FAIL';
export const DELETE_WCC_MOT_REQUEST = 'DELETE_WCC_MOT_REQUEST';

export const CLEAR_WCC_MOT_DATA = 'CLEAR_WCC_MOT_DATA ';

const postWccMotRequest = () => ({ type: POST_WCC_MOT_REQUEST });
const postWccMotSuccess = (data) => ({ type: POST_WCC_MOT_SUCCESS, payload: data });
const postWccMotFail = (error) => ({ type: POST_WCC_MOT_FAIL, error });

const loadWccMotRequest = () => ({ type: LOAD_WCC_MOT_REQUEST });
const loadWccMotSuccess = (data) => ({ type: LOAD_WCC_MOT_SUCCESS, payload: data });
const loadWccMotFail = (error) => ({ type: LOAD_WCC_MOT_FAIL, error });

const loadWccMotDataRequest = () => ({ type: LOAD_WCC_MOT_DATA_REQUEST });
const loadWccMotDataSuccess = (data) => ({ type: LOAD_WCC_MOT_DATA_SUCCESS, payload: data });
const loadWccMotDataFail = (error) => ({ type: LOAD_WCC_MOT_DATA_FAIL, error });

const loadManufacturingOrderTypesRequest = () => ({ type: LOAD_MANUFACTURING_ORDER_TYPES_REQUEST });
const loadManufacturingOrderTypesSuccess = (data) => ({ type: LOAD_MANUFACTURING_ORDER_TYPES_SUCCESS, payload: data });
const loadManufacturingOrderTypesFail = (error) => ({ type: LOAD_MANUFACTURING_ORDER_TYPES_FAIL, error });

const putWccMotRequest = () => ({ type: PUT_WCC_MOT_REQUEST });
const putWccMotSuccess = () => ({ type: PUT_WCC_MOT_SUCCESS });
const putWccMotFail = (error) => ({ type: PUT_WCC_MOT_FAIL, error });

const deleteWccMotRequest = () => ({ type: DELETE_WCC_MOT_REQUEST });
const deleteWccMotSuccess = (id) => ({ type: DELETE_WCC_MOT_SUCCESS, payload: id });
const deleteWccMotFail = (error) => ({ type: DELETE_WCC_MOT_FAIL, error });

export const clearWccMotData = () => ({ type: CLEAR_WCC_MOT_DATA });

function reformatForOptionsMenu(data) {
  return data.map((item) => ({
    value: item.Id,
    label: item.WorkCenterCodeName || item.Name
  }));
}

export const loadWccMot = () => (dispatch) => {
  dispatch(loadWccMotRequest());
  return communicate({ url: 'WorkCenterCodes' })
    .then((response) => {
      dispatch(loadWccMotSuccess(reformatForOptionsMenu(response.data.Data)));
    }).catch((err) => {
      dispatch(loadWccMotFail(err));
      toastrError(err);
    });
};

export const loadWccMotData = () => (dispatch) => {
  dispatch(loadWccMotDataRequest());
  return communicate({ url: 'PaymentCodes' })
    .then((response) => {
      dispatch(loadWccMotDataSuccess(response.data.Data));
    }).catch((err) => {
      dispatch(loadWccMotDataFail(err));
      toastrError(err);
    });
};

export const loadManufacturingOrderTypes = () => (dispatch) => {
  dispatch(loadManufacturingOrderTypesRequest());
  return communicate({ url: 'ManufacturingOrderTypes' })
    .then((response) => {
      dispatch(loadManufacturingOrderTypesSuccess(reformatForOptionsMenu(response.data.Data)));
    })
    .catch((err) => {
      dispatch(loadManufacturingOrderTypesFail(err));
      toastrError(err);
    });
};


export const postWccMot = (data) => (dispatch) => {
  dispatch(postWccMotRequest());
  return communicate({ url: 'PaymentCodes', method: 'post', data })
    .then((response) => {
      dispatch(postWccMotSuccess(response.data.Data));
      toastrSuccess(response);
    }).catch((err) => {
      dispatch(postWccMotFail(err));
      toastrError(err);
    });
};

export const putWccMot = (data) => (dispatch) => {
  dispatch(putWccMotRequest());
  return communicate({ url: 'PaymentCodes', method: 'put', data })
    .then((response) => {
      dispatch(putWccMotSuccess(response.data.Data));
      toastrSuccess(response);
      dispatch(loadWccMotData());
    }).catch((err) => {
      dispatch(putWccMotFail(err));
      toastrError(err);
    });
};

export const deleteWccMot = (id) => (dispatch) => {
  dispatch(deleteWccMotRequest());
  return communicate({ url: 'PaymentCodes', method: 'delete', getParams: `?id=${id}` })
    .then((response) => {
      toastrSuccess(response);
      dispatch(deleteWccMotSuccess(id));
    }).catch((err) => {
      dispatch(deleteWccMotFail(err));
      toastrError(err);
    });
};
